const FALLBACK_FLAG = "/main/img/theme-img/worldwide.svg";

/**
 * Overrides for country names whose flag filenames
 * don't follow the simple lowercase-dash convention.
 */
const FLAG_OVERRIDES: Record<string, string> = {
  "united arab emirates": "emirates",
  "saudi arabia": "ksa",
  turkiye: "turkey",
  "costa rica": "costarica",
  brazil: "brazil-",
};

/**
 * Returns the flag image path for a given country name.
 * Falls back to a globe icon when no flag file is mapped.
 */
export function getCountryFlag(countryName: string): string {
  const key = countryName.toLowerCase().trim();
  const file = FLAG_OVERRIDES[key] ?? key.replace(/\s+/g, "-");
  return `/flags/${file}.svg`;
}

export { FALLBACK_FLAG };
